export function handleProductHtml() {
  const htmlEl = document.querySelector('.js-product-html')

  if (!htmlEl) {
    return
  }

  const contentEl = htmlEl.querySelector('.js-product-html-content')
  const btnShowEl = htmlEl.querySelector('.js-product-html-btn-show')
  const btnHideEl = htmlEl.querySelector('.js-product-html-btn-hide')

  btnShowEl.addEventListener('click', () => {
    contentEl.classList.add('opened')
    btnShowEl.classList.add('hidden')
  })

  btnHideEl.addEventListener('click', () => {
    contentEl.classList.remove('opened')
    btnShowEl.classList.remove('hidden')

    window.scrollTo({
      top: htmlEl.offsetTop - 20,
      behavior: 'smooth'
    })
  })
}
